exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TATXWClAAHji_R{font-size:16px;font-weight:700;text-align:center}.cJx0Rsx8LhOFnb{color:#5e6c84;margin:8px 0 12px;text-align:center}.sckGFtKJCbOiN3{max-height:180px;min-height:64px;overflow-x:hidden;overflow-y:scroll}._1Kx6YxkA-TIJxY{color:#6b778c;font-size:12px;font-style:italic;margin:8px 0 4px;text-align:center}._23jMEsEsAvs_WS{margin-bottom:0}._2geRY0m_N4sNaj{border-bottom:1px solid rgba(9,30,66,.08);display:flex;height:34px;padding:3px 0 2px}._2geRY0m_N4sNaj label{margin:8px 0 0}._2geRY0m_N4sNaj input,._2geRY0m_N4sNaj label,._2geRY0m_N4sNaj span{cursor:pointer}.zOXYts8LOk1O-S{flex-shrink:0;margin-top:6px;width:20px}._21Ecin4LAC62Cu{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex-grow:1;line-height:34px;padding:0 8px}._2vCWpya2chOslo{flex-shrink:0;width:20px}", ""]);

// exports
exports.locals = {
	"addPeopleTitle": "TATXWClAAHji_R",
	"addPeopleDescription": "cJx0Rsx8LhOFnb",
	"addPeopleList": "sckGFtKJCbOiN3",
	"addPeopleSubmitMessaging": "_1Kx6YxkA-TIJxY",
	"addPeopleButton": "_23jMEsEsAvs_WS",
	"addPeopleListItem": "_2geRY0m_N4sNaj",
	"addPeopleListItemAvatar": "zOXYts8LOk1O-S",
	"addPeopleListItemName": "_21Ecin4LAC62Cu",
	"addPeopleListItemCheckbox": "_2vCWpya2chOslo"
};